import { apiClient } from '@/shared/api';
import type {
  KnowledgeSetCreateRequest,
  KnowledgeSetCreateResponse,
  KnowledgeSetResponse,
  KnowledgeSetUpdateRequest,
  KnowledgeSetUpdateResponse,
} from './types';

export type {
  KnowledgeNodeInSet,
  KnowledgeSetCreateRequest,
  KnowledgeSetCreateResponse,
  KnowledgeSetListItem,
  KnowledgeSetResponse,
  KnowledgeSetUpdateRequest,
  KnowledgeSetUpdateResponse,
} from './types';

/**
 * Fetch a knowledge set by ID per GET /knowledge-set/{id}
 */
export const fetchKnowledgeSet = async (id: number | string): Promise<KnowledgeSetResponse> => {
  const { data } = await apiClient.get<KnowledgeSetResponse>(`/knowledge-set/${id}`);
  return data;
};

/**
 * Create a knowledge set per POST /knowledge-set
 */
export const createKnowledgeSet = async (payload: KnowledgeSetCreateRequest): Promise<KnowledgeSetCreateResponse> => {
  const { data } = await apiClient.post<KnowledgeSetCreateResponse>('/knowledge-set', payload);
  return data;
};

/**
 * Update a knowledge set per PUT /knowledge-set/{id}
 */
export const updateKnowledgeSet = async (
  id: number | string,
  payload: KnowledgeSetUpdateRequest,
): Promise<KnowledgeSetUpdateResponse> => {
  const { data } = await apiClient.put<KnowledgeSetUpdateResponse>(`/knowledge-set/${id}`, payload);
  return data;
};

/**
 * Delete a knowledge set per DELETE /knowledge-set/{id}
 */
export const deleteKnowledgeSet = async (id: number | string): Promise<void> => {
  await apiClient.delete(`/knowledge-set/${id}`);
};
